export enum VideoRoomDisplayMode {
    Desktop = 1,
    Mobile,
}
